// import external dependencies
import 'jquery';

// utils
// import { PreventFragment} from './utils/PreventFragment';


// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
// common
import { Animation } from './common/Animation';
// layouts
import { Header } from './layouts/Header';
import { VideoModal } from './layouts/VideoModal'
import { SocialShares } from './layouts/SocialShares'
// modules
import { Home } from './modules/Home';
import { Flexible } from './modules/Flexible';
import { Sliders } from './modules/Sliders';
import { Archive } from './modules/Archive';
import { RecentContent } from './modules/RecentContent';
import { Search } from './modules/Search';
import { Form } from './modules/Form';
import { Post } from './modules/Post';
import { ResearchGuide } from './modules/ResearchGuide';
import { Event } from './modules/Event';
import { ReferrerCookie } from './misc/ReferrerCookie';
import { LandingPage } from './modules/LandingPage';
import { FAQ } from './modules/FAQ';

// Load Events
jQuery(document).ready(() => {
  // misc
  ReferrerCookie.onLoad();
  // common
  Animation.onLoad();
  // layouts
  Header.onLoad();
  VideoModal.onLoad();
  SocialShares.onLoad();
  // modules
  Home.onLoad();
  Archive.onLoad();
  RecentContent.onLoad();
  Flexible.onLoad();
  Sliders.onLoad();
  Search.onLoad();
  Form.onLoad();
  Post.onLoad();
  ResearchGuide.onLoad();
  Event.onLoad();
  FAQ.onLoad();
  // PreventFragment.onLoad();
  LandingPage.onLoad();
});



// WEBPACK FOOTER //
// ./scripts/main.js